export const LieDeceiveAndWin = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 250"
      width="100%"
      preserveAspectRatio="xMidYMid meet"
    >
      <style>
        {`
          text {
            font-family: "Comic Sans MS", "Arial Rounded MT Bold", "Trebuchet MS", sans-serif;
            font-weight: 700;
            fill: white;
            stroke: black;
            stroke-width: 14px;
            paint-order: stroke fill;
          }
        `}
      </style>

      {/* Single Line Text */}
      <text
        x="50%"
        y="60%"
        textAnchor="middle"
        fontSize="120"
        textLength="1050"
        lengthAdjust="spacingAndGlyphs"
      >
        .Lie. Deceive. Win
      </text>
    </svg>
  );
};
